
  import constants, { DATE_FORMATS } from '@/common/constants';
  import { TDateFormats } from '@/common/types/date';
  import { parseDateToIsoDay } from '@/common/utils/dates';

  import EChartsLine from '@/components/ChartComponents/apacheEcharts/EChartsLine.vue';
  import { TEChartsTitleConfig } from '@/components/ChartComponents/apacheEcharts/types';

  import Api from '../api';
  import { IMonetaryChartItem, IMonetaryChartSeries } from '../types/monetary';

  export default {
    name: 'MonetaryChart',
    components: {
      EChartsLine,
    },
    props: {
      countryId: {
        type: String,
        required: true,
      },
    },
    data(): {
      series: IMonetaryChartSeries[];
      isLoading: boolean;
    } {
      return {
        series: [],
        isLoading: false,
      };
    },
    async mounted() {
      await this.fetchData();
    },
    computed: {
      getChartTitleConfig(): TEChartsTitleConfig {
        return {
          text: 'Основные показатели денежно-кредитной политики',
          tooltipContent: constants.tooltipLegendCommon,
        };
      },
      getTimeValueFormat(): TDateFormats {
        return DATE_FORMATS['MMM, YYYY'];
      },
    },
    methods: {
      async fetchData() {
        this.isLoading = true;
        try {
          const apiResponse = await Api.getMonetaryPolicyChart(this.countryId);
          const responseItems: IMonetaryChartItem[] = apiResponse?.data ?? [];
          const orderedPoints = responseItems.map((chartItem: IMonetaryChartItem) => ({
            x: parseDateToIsoDay(chartItem.date),
            inflation: chartItem.inflation,
            bankRate: chartItem.bankRate,
          }));
          const inflationSeriesPoints = orderedPoints.filter((dataPoint) => Number.isFinite(dataPoint.inflation));
          const bankRateSeriesPoints = orderedPoints.filter((dataPoint) => Number.isFinite(dataPoint.bankRate));
          const inflationSeries = {
            name: 'Инфляция, % г/г',
            data: inflationSeriesPoints.map((dataPoint) => ({ x: dataPoint.x, y: dataPoint.inflation })),
          };
          const bankRateSeries = {
            name: 'Ключевая ставка, % годовых',
            data: bankRateSeriesPoints.map((dataPoint) => ({ x: dataPoint.x, y: dataPoint.bankRate })),
          };
          const seriesToRender = [];

          if (inflationSeries.data.length > 0) seriesToRender.push(inflationSeries);
          if (bankRateSeries.data.length > 0) seriesToRender.push(bankRateSeries);
          this.series = seriesToRender;
        } catch (error) {
          this.series = [];
        } finally {
          this.isLoading = false;
        }
      },
    },
    watch: {
      countryId() {
        this.fetchData();
      },
    },
  };
